module.exports = __webpack_public_path__ + "img/RedteaSIM.a904db3a.png";